import { AfterContentInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { Configuration } from 'src/app/domain/configuration';
import { TestGroup } from 'src/app/domain/test-group';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-test-group-selector-box',
    templateUrl: './test-group-selector-box.component.html',
    styleUrl: './test-group-selector-box.component.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatSelectModule, ReactiveFormsModule, FormsModule, MatOptionModule, MatButtonModule, PreventDoubleClickDirective]
})
export class TestGroupSelectorBoxComponent implements OnInit, AfterContentInit {

    TestGroupList?: TestGroup[] = [];
    SelectedGroup?: TestGroup;

    constructor(
        public dialogRef: MatDialogRef<TestGroupSelectorBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.TestGroupList = data.testGroupList;
        }
    }
    ngOnInit(): void {
    }

    ngAfterContentInit(): void {

    }

    CanSave() {
        return true;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.CanSave())
            this.dialogRef.close(this.SelectedGroup?.Code);

    }
}
